export default "__VITE_ASSET__lHJ4y_Qg__";